import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createInvoiceEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: event =>
      createEventFunc({
        ...payload,
        path: `_hook.${hookId}`,
        slots: () => [
          ...((payload.slots && payload.slots(event)) || []),
          {
            slot: "id",
            is: "u-invoice-link",
            message: _.get(event, "object.number"),
            class: "has-text-dark has-text-underlined",
            props: {
              invoiceId: _.get(event, "object.id")
            }
          }
        ]
      })(event)
  }
});

export default {
  ...createInvoiceEventMap(HookCodes.INVOICE_ADJUSTED),
  ...createInvoiceEventMap(HookCodes.INVOICE_CANCELLED, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_COMMISSIONS_MANUALLY_CALCULATED),
  ...createInvoiceEventMap(HookCodes.INVOICE_CREATED, {
    icon: icon.success
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_CREDITED),
  ...createInvoiceEventMap(HookCodes.INVOICE_DUPLICATED),
  ...createInvoiceEventMap(HookCodes.INVOICE_OVERDUE_NOTIFICATION, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAID),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAYMENT_CARD_EXPIRED),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAYMENT_FAILED, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAYMENT_MISSING_DATA, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAYMENT_RECEIVED, {
    slots: event => [
      {
        slot: "amount",
        is: "strong",
        message: _.get(event, "object.amount_formatted")
      }
    ]
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_PDF_GENERATED),
  ...createInvoiceEventMap(HookCodes.INVOICE_REFRESHED),
  ...createInvoiceEventMap(HookCodes.INVOICE_REFUNDED, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_UPDATED_DUE_DATE),
  ...createInvoiceEventMap(HookCodes.INVOICE_CAPTURE_FAILED, {
    icon: icon.warning
  }),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAID_WITH_NEXT_CARD),
  ...createInvoiceEventMap(HookCodes.INVOICE_3D_PAYMENT_REQUIRED),
  ...createInvoiceEventMap(HookCodes.INVOICE_PRE_DUE_NOTIFICATION),
  ...createInvoiceEventMap(HookCodes.INVOICE_REFUND_REQUESTED),
  ...createInvoiceEventMap(HookCodes.INVOICE_PAYMENT_REFUNDED)
};
